module.exports = __webpack_public_path__ + "3be1d8dec7970986b0536c06c0f9be6d.svg";